export const CREATE_BIKE_MODEL_VARIANTS_REQUEST = 'CREATE_BIKE_MODEL_VARIANTS_REQUEST';
export const CREATE_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS = 'CREATE_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS';
export const CREATE_BIKE_MODEL_VARIANTS_REQUEST_FAILURE = 'CREATE_BIKE_MODEL_VARIANTS_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_variant_create/redux/constants/create_bike_model_variant.constants.js